import React, { useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { NotificationManager } from "react-notifications";
import { Link, useNavigate } from "react-router-dom";
import { useStores } from "_common/hooks";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AuthApi } from "states/api";
import { observer } from "mobx-react-lite";
import i18next from "i18next";

import HeaderTop from "_common/component/Layout/Header/HeaderTop";

import icon1 from "assets/img/member/icon1.svg";
import icon2 from "assets/img/member/icon2.svg";
import icon3 from "assets/img/member/icon3.svg";
import icon4 from "assets/img/member/icon4.svg";
import icon5 from "assets/img/member/icon5.svg";
import icon6 from "assets/img/member/icon6.svg";
import icon7 from "assets/img/member/icon7.svg";
import icon8 from "assets/img/member/icon8.svg";
import icon9 from "assets/img/member/icon9.svg";
import icon10 from "assets/img/member/icon10.svg";
import icon11 from "assets/img/member/icon11.svg";

const MemberPage = observer(() => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const {
    authStore: { user, languages, language, clear },
  } = useStores();

  const { mutate: onLogout } = useMutation(AuthApi.logout, {
    onSuccess: (res) => {
      clear();
    },
    onError: (error) => {
      clear();
      const errorMessage =
        i18next.t(error?.message) ?? i18next.t("action_failed_msg");
      NotificationManager.error(errorMessage);
    },
  });

  const langData = useMemo(
    () => languages?.find((obj) => obj?.code === language),
    [languages, language]
  );

  return (
    <div className="member-page">
      <HeaderTop
        title={i18next.t("member_center")}
        onBack={() => navigate("/board")}
      />
      <div className="no_inbox">
        <div className="link">
          <div className="lbox">
            <div className="lbox_l flex items-center">
              <img src={icon1} className="w-[20px] h-[20px]" alt="" />
              <span className="ml-[10px] text-white">
                {i18next.t("username")}
              </span>
            </div>
            <div className="lbox_r">
              <span className="text-gray-400">{user?.username}</span>
            </div>
          </div>
        </div>
        <div className="link">
          <div className="lbox">
            <div className="lbox_l flex items-center">
              <img src={icon2} className="w-[20px] h-[20px]" alt="" />
              <span className="ml-[10px] text-white">{i18next.t("user")}</span>
            </div>
            <div className="lbox_r">
              <span className="text-gray-400">{user?.email}</span>
            </div>
          </div>
        </div>
        <div className="link">
          <div className="lbox">
            <div className="lbox_l flex items-center">
              <img src={icon3} className="w-[20px] h-[20px]" alt="" />
              <span className="ml-[10px] text-white">{i18next.t("phone")}</span>
            </div>
            <div className="lbox_r">
              <span className="text-gray-400">{user?.phone_display}</span>
            </div>
          </div>
        </div>
        <Link to="/member/password">
          <div className="lbox ">
            <div className="lbox_l flex items-center">
              <img src={icon5} className="w-[20px] h-[20px]" alt="" />
              <span className="ml-[10px] text-white ">
                {i18next.t("modify_password")}
              </span>
            </div>
            <div className="lbox_r">
              <FontAwesomeIcon icon={faArrowRight} width="16" color="#9098A3" />
            </div>
          </div>
        </Link>
        <Link to="/member/wallet-password">
          <div className="lbox ">
            <div className="lbox_l flex items-center">
              <img src={icon4} className="w-[20px] h-[20px]" alt="" />
              <span className="ml-[10px] text-white ">
                {i18next.t("modify_wallet_password")}
              </span>
            </div>
            <div className="lbox_r">
              <FontAwesomeIcon icon={faArrowRight} width="16" color="#9098A3" />
            </div>
          </div>
        </Link>
      </div>
      <div className="no_inbox">
        <Link to="/member/wallet">
          <div className="lbox ">
            <div className="lbox_l flex items-center">
              <img src={icon6} className="w-[20px] h-[20px]" alt="" />
              <span className="ml-[10px] text-white ">
                {i18next.t("bind_wallet")}
              </span>
            </div>
            <div className="lbox_r">
              <FontAwesomeIcon icon={faArrowRight} width="16" color="#9098A3" />
            </div>
          </div>
        </Link>
        <div
          className="link"
          onClick={() => {
            if (user?.level !== 2) {
              navigate("/member/kyc");
            }
          }}
        >
          <div className="lbox ">
            <div className="lbox_l flex items-center">
              <img src={icon7} className="w-[20px] h-[20px]" alt="" />

              <span className="ml-[10px] text-white ">
                {i18next.t("verify_kyc")}
              </span>
            </div>
            <div className="lbox_r">
              <span className="text-sm mr-2 text-[#9098A3]">
                {user?.level ? `Lv.${user?.level}` : i18next.t("un_verify")}
              </span>
              <FontAwesomeIcon icon={faArrowRight} width="16" color="#9098A3" />
            </div>
          </div>
        </div>
      </div>
      <div className="no_inbox">
        <Link to="/language">
          <div className="lbox  ">
            <div className="lbox_l flex items-center">
              <img src={icon8} className="w-[20px] h-[20px]" alt="" />

              <span className="ml-[10px] text-white ">
                {i18next.t("language")}
              </span>
            </div>
            <div className="lbox_r">
              <span className="text-sm mr-2 text-[#9098A3]">
                {langData?.text}
              </span>
              <FontAwesomeIcon icon={faArrowRight} width="16" color="#9098A3" />
            </div>
          </div>
        </Link>
        <Link to="/member">
          <div className="lbox">
            <div className="lbox_l flex items-center">
              <img src={icon9} className="w-[20px] h-[20px]" alt="" />

              <span className="ml-[10px] text-white ">
                {i18next.t("color_chart")}
              </span>
            </div>
            <div className="lbox_r">
              <span className="text-sm mr-2 text-[#9098A3]">
                {i18next.t("note3")}
              </span>
              <FontAwesomeIcon icon={faArrowRight} width="16" color="#9098A3" />
            </div>
          </div>
        </Link>
        <Link to="/member">
          <div className="lbox">
            <div className="lbox_l flex items-center">
              <img src={icon10} className="w-[20px] h-[20px]" alt="" />

              <span className="ml-[10px] text-white ">
                {i18next.t("currency_display")}
              </span>
            </div>
            <div className="lbox_r">
              <span className="text-sm mr-2 text-[#9098A3]">USD</span>
              <FontAwesomeIcon icon={faArrowRight} width="16" color="#9098A3" />
            </div>
          </div>
        </Link>
        <Link to="/introduction">
          <div className="lbox">
            <div className="lbox_l flex items-center">
              <img src={icon11} className="w-[20px] h-[20px]" alt="" />

              <span className="ml-[10px] text-white ">
                {i18next.t("introduction")}
              </span>
            </div>
            <div className="lbox_r">
              <FontAwesomeIcon icon={faArrowRight} width="16" color="#9098A3" />
            </div>
          </div>
        </Link>
      </div>
      <div className="p-5 bg-black">
        <button
          type="button"
          className="py-2 w-full text-white bg-red-600 rounded-md text-[13px] font-semibold"
          onClick={onLogout}
        >
          {i18next.t("log_out")}
        </button>
      </div>
    </div>
  );
});

export default MemberPage;
